export const ADDRESSES_API_URL = 'ui/organization/addresses';

export const addressesQueryKeys = {
  all: [ADDRESSES_API_URL],
};
